// data = {}
export const calcPreBalance = (data, type = "invoice") => {
  const balanceAmt = Number(data.balanceAmt || 0);
  const salesAmt = Number(data[type === "invoice" ? "totalSalesAmt" : "totalIssuedSalesAmt"] || 0);
  const purchaseAmt = Number(data[type === "invoice" ? "totalPurchaseAmt" : "totalIssuedPurchaseAmt"] || 0);
  const accountInAmt = Number(data['totalAccountInAmt'] || 0);
  const accountOutAmt = Number(data['totalAccountOutAmt'] || 0);
  const preBalanceAmt = balanceAmt - salesAmt + purchaseAmt + accountInAmt - accountOutAmt;
  return preBalanceAmt;
};